import { useState, useEffect, useCallback } from 'react';
import { i18n } from './index.js';

export function useTranslation() {
  const [currentLanguage, setCurrentLanguage] = useState(i18n.getCurrentLanguage());

  useEffect(() => {
    const unsubscribe = i18n.subscribe(setCurrentLanguage);
    return unsubscribe;
  }, []);

  const t = useCallback((key, params = {}) => {
    return i18n.t(key, params);
  }, []);

  const setLanguage = useCallback((language) => {
    i18n.setLanguage(language);
  }, []);

  const getCurrentLanguage = useCallback(() => {
    return i18n.getCurrentLanguage();
  }, []);

  const getAvailableLanguages = useCallback(() => {
    return i18n.getAvailableLanguages();
  }, []);

  return {
    t,
    currentLanguage,
    setLanguage,
    getCurrentLanguage,
    getAvailableLanguages
  };
}
